import { ActionTree } from "vuex";
import { ModalState } from "./state";
import { h } from "vue";
import { fmtMsg } from "vue-glcommonui";
import { CommonLocale, IndependentLocales, MediaDeviceErrors, SessionReplacementLocales } from "@/locales/localeid";
import { Paths } from "@/utils/paths";
import router from "@/router";
import DeviceWarningContent from "@/components/common/device-warning-content/device-warning-content.vue";
import { defineVuexName, vuexName, MODULES } from "../utils";
import { CameraCustomErrorCode, MicrophoneCustomErrorCode } from "@/agora/utils";

export enum DynamicModalNames {
  CameraWarning = "CameraWarning",
  MicrophoneWarning = "MicrophoneWarning",
}

const actions: ActionTree<ModalState, any> = {
  //warningIdpModeBeforeExecute
  async [defineVuexName(MODULES.MODAL.DISPATCHES.WARNING_IDP_MODE_BEFORE_EXECUTE)]({ commit, dispatch }, callback: () => Promise<void>) {
    commit(vuexName(MODULES.MODAL.COMMITS.OPEN, false), {
      view: h("div", { innerHTML: fmtMsg(IndependentLocales.StopWarning) }),
      title: fmtMsg(IndependentLocales.StopMode),
      actions: [
        {
          label: fmtMsg(CommonLocale.CommonOkButtonText),
          callback: async () => {
            commit(vuexName(MODULES.MODAL.COMMITS.CLOSE, false));
            await dispatch(vuexName(MODULES.TEACHER_TEACHING.DISPATCHES.TOGGLE_INDEPENDENT_MODE), null, { root: true });
            await callback();
          },
        },
      ],
    });
  },
  //confirmReplacementSession
  async [defineVuexName(MODULES.MODAL.DISPATCHES.CONFIRM_REPLACEMENT_SESSION)]({ commit }, callback: () => Promise<void>) {
    commit(vuexName(MODULES.MODAL.COMMITS.OPEN, false), {
      view: h("div", { innerHTML: fmtMsg(SessionReplacementLocales.Description) }),
      title: fmtMsg(SessionReplacementLocales.Title),
      actions: [
        {
          label: fmtMsg(CommonLocale.CommonOkButtonText),
          callback: async () => {
            commit(vuexName(MODULES.MODAL.COMMITS.CLOSE, false));
            await callback();
          },
        },
        {
          callback: async () => {
            await router.push(Paths.Home);
          },
        },
      ],
    });
  },
  async [defineVuexName(MODULES.MODAL.DISPATCHES.INFORM_DEVICE_WARNING)](
    { commit },
    { code, callback, isCamera }: { code: string; title: string; isCamera: boolean; callback: () => Promise<void> },
  ) {
    let title = "";

    if (isCamera) {
      switch (code) {
        case CameraCustomErrorCode.CAMERA_DEVICE_IN_USE:
          title = fmtMsg(MediaDeviceErrors.CameraInUse);
          break;
        case CameraCustomErrorCode.CAMERA_PERMISSION_DENIED:
          title = fmtMsg(MediaDeviceErrors.CameraPermissionDenied);
          break;
        default:
          title = fmtMsg(MediaDeviceErrors.CameraInUse);
          break;
      }
    } else {
      switch (code) {
        case MicrophoneCustomErrorCode.MICROPHONE_DEVICE_IN_USE:
          title = fmtMsg(MediaDeviceErrors.MicrophoneInUse);
          break;
        case MicrophoneCustomErrorCode.MICROPHONE_PERMISSION_DENIED:
          title = fmtMsg(MediaDeviceErrors.MicrophonePermissionDenied);
          break;
        default:
          title = fmtMsg(MediaDeviceErrors.MicrophoneInUse);
          break;
      }
    }

    commit(vuexName(MODULES.MODAL.COMMITS.OPEN, false), {
      view: h(DeviceWarningContent, { code }),
      title: title,
      name: isCamera ? DynamicModalNames.CameraWarning : DynamicModalNames.MicrophoneWarning,
      actions: [
        {
          label: fmtMsg(MediaDeviceErrors.TryAgain),
          callback: async () => {
            await callback();
          },
        },
        {
          callback: async () => {
            commit(vuexName(MODULES.MODAL.COMMITS.CLOSE, false));
          },
        },
      ],
    });
  },
};

export default actions;
